// Защита от повторного оформления заказа в одной сессии.
// После успешного `createOrder` в registration-flow мы пишем маркер в
// sessionStorage. Пока маркер «свежий», submitForm и verifyCode молча отказываются
// запускать второй заказ — UI показывает баннер «Заказ уже оформлен, перейти в кабинет».
//
// Это не заменяет серверную idempotency-проверку — но закрывает 90% реальных
// дублей: «нажал назад в браузере после оплаты и снова прошёл форму».

const KEY = 'forum-industry.order-created';
const TTL_MS = 60 * 60 * 1000; // 1 час

export function markOrderCreated(payload = {}) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ ...payload, createdAt: Date.now() })
    );
  } catch {}
}

export function hasFreshOrderMarker() {
  if (typeof sessionStorage === 'undefined') return false;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.createdAt !== 'number') return false;
    return Date.now() - parsed.createdAt < TTL_MS;
  } catch {
    return false;
  }
}

export function readOrderMarker() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.createdAt !== 'number') return null;
    if (Date.now() - parsed.createdAt >= TTL_MS) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearOrderMarker() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
}

// =========================================================================
// Post-payment маркер — отдельный сигнал «юзер реально оплатил».
//
// Маркер order-created ставится сразу после createOrder, ДО редиректа на
// YooKassa. Использовать его как гейт для polling статуса оплаты неверно:
// если юзер закроет YooKassa без оплаты и вернётся в кабинет — маркер
// свежий, polling крутится впустую и показывает «Платёж обрабатывается».
//
// Post-payment маркер ставится ТОЛЬКО когда YooKassa вернула юзера на
// /account?paid=1 (success_payment_url). Хранит id pending-заказа, по
// которому ждём смену статуса. Поллер обновляет именно его и снимает
// маркер при success/timeout.
//
// TTL 24 ч — webhook обычно за минуты, но если упал и юзер зайдёт через
// сутки, маркер истечёт и polling не будет цепляться к старому событию.

const PAYMENT_RETURN_KEY = 'forum-industry.payment-return';
const PAYMENT_RETURN_TTL_MS = 24 * 60 * 60 * 1000; // 24 часа

export function markPaymentReturn(orderIds = []) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(
      PAYMENT_RETURN_KEY,
      JSON.stringify({
        orderIds: Array.isArray(orderIds) ? orderIds : [],
        markedAt: Date.now()
      })
    );
  } catch {}
}

export function readPaymentReturn() {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(PAYMENT_RETURN_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed.markedAt !== 'number') return null;
    if (Date.now() - parsed.markedAt >= PAYMENT_RETURN_TTL_MS) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearPaymentReturn() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(PAYMENT_RETURN_KEY);
  } catch {}
}
